export const getDataFromLocalstorageByKey = (key: string) => {
  if (!key) return undefined;
  const dataLocal = localStorage.getItem(key);
  if (dataLocal !== null) {
    return JSON.parse(dataLocal);
  } else {
    return undefined;
  }
};
